import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable()
export class RenovacaoService {
  constructor(private http: HttpClient) {}

  getCertificates(
    idOrganizacao: number,
    page: number,
    size: number,
    dias: number,
    enviados: boolean = false,
    filtro: string = ""
  ): Promise<any> {
    const url =
      environment.backendBaseUrl +
      `/manager/renovacao/organizacao/${idOrganizacao}?page=${page}&size=${size}&dias=${dias}&enviados=${enviados}&filtro=${filtro}`;

    return this.http.get(url).toPromise().catch(this.handleError);
  }

  getProducts(): Promise<any> {
    const url = environment.backendBaseUrl + `/manager/renovacao/lotes`;

    return this.http.get(url).toPromise().catch(this.handleError);
  }

  sendEmail(ids: Number[], product: any, client: any): Promise<any> {
    const url =
      environment.backendBaseUrl + `/manager/renovacao/processar-renovacao`;

    return this.http
      .post(url, {
        ids,
        ...product,
        organizacaoId: client.organizacaoId,
        certificadoComunicacaoId: client.certificadoComunicacaoId,
      })
      .toPromise()
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error("OCORREU UM ERRO:", error.error.message);
    return Promise.reject(error.error.message || error);
  }

  getTermoRenovacao(desafio: String): Promise<any> {
    const url =
      environment.backendBaseUrl + `/manager/renovacao/termo-renovacao`;

    return this.http.post(url, { desafio }).toPromise().catch(this.handleError);
  }

  assinarTermo(
    desafio: string,
    termoRenovacao: string,
    emailUsuario: string,
    pinUsuario: string
  ): Promise<any> {
    const url = environment.backendBaseUrl + `/manager/renovacao/assinar-termo`;

    return this.http
      .post(url, {
        desafio,
        termoRenovacao,
        emailUsuario,
        pinUsuario,
      })
      .toPromise()
      .catch(this.handleError);
  }
}
